<template>
  <div class="brandIdBlock">
    <el-button type="primary" v-if="!batchBrand" @click="useBrandConf" style="margin-bottom: 10px">一键应用品牌配置</el-button>
    <el-input
      v-if="!batchBrand"
      width="200px"
      style="margin-left: 10px"
      type="text"
      clearable
      placeholder="输入品牌,回车后匹配填充"
      v-model="inputBrandText"
      @keyup.enter.native="batchFillBrand"
    >
    </el-input>

    <div class="brandId-row" v-for="shop in shopList" :key="shop.id">
      <el-image :src="shop.icon" style="width: 26px; height: 26px; border-radius: 50%"></el-image>
      <span class="shop-title">{{ shop.shortTitle || shop.title }}</span>
      <el-select
        :value="valueMap[shop.id]"
        value-key="brandId"
        name-key="brandName"
        :loading="loading[shop.id]"
        clearable
        @visible-change="isShow => visibleSelect(isShow, shop.id, shop.userId)"
        @change="v => selectChange(v, shop.id)"
      >
        <el-option v-for="brandOp in brandOptions[shop.id]" :key="brandOp.brandId" :label="brandOp.brandName" :value="brandOp"> </el-option>
      </el-select>
      <el-link
        v-if="valueMap && valueMap[shop.id] && valueMap[shop.id].brandId && !batchBrand"
        style="margin-left: 8px"
        @click="handleSetToShop(shop, valueMap[shop.id].brandName)"
        >应用到其他店铺</el-link
      >
    </div>
    <el-dialog-select-shop
      :visible.sync="shopDialogVisible"
      :shopData="shopList"
      :selected="selectShopIds"
      placeholder="店铺名称"
      @confirm="confirmSelectShop"
    ></el-dialog-select-shop>
  </div>
</template>

<script>
import { getWxsphBrandList } from '@/servers/prod/center/wxh.js';
import { getShopsBrandFill, ApplyToOtherShop } from '@/servers/prod/center/wxh.js';
import { getApplyBrandConfig } from '@/servers/prod/center/pdd.js';
import _ from 'lodash';
const PLATFORMID = 'wxsph';
export default {
  name: 'BrandIdBlock',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    shopList: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    batchBrand: {
      type: Boolean,
      default: false,
    },
    source: {
      type: String, // 来源于详情还是批量删除页面，批量删除页面不需要默认根据店铺列表获取列表接口 batchDelete
      default: '',
    },
    baseItemId: [String, Number],
    categoryId: {
      required: true,
    },
  },
  data() {
    return {
      inputBrandText: '',
      valueMap: {},
      brandOptions: {},
      loading: {},
      getFail: {},
      shopDialogVisible: false,
      selectShopIds: '',
      applyShopName: '', // 发货时效应用的店铺名称
      _isUpdatingFromValue: false, // 防止循环更新的标志位
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(v) {
        // 防止循环更新
        this._isUpdatingFromValue = true;
        if (v && v.length) {
          // 清空现有的valueMap，避免残留数据
          this.valueMap = {};
          v.forEach(item => {
            this.$set(this.valueMap, item.shopId, item);
          });
        } else {
          // 当value为空时，清空valueMap
          this.valueMap = {};
        }
        this.$nextTick(() => {
          this._isUpdatingFromValue = false;
        });
      },
    },
    valueMap: {
      deep: true,
      handler(v) {
        // 如果是从value更新触发的，不再触发change事件，避免循环
        if (this._isUpdatingFromValue) {
          return;
        }
        let brandList = Object.values(v).filter(item => item && item.brandId);
        this.$emit('change', brandList);
      },
    },
  },
  methods: {
    visibleSelect(isShow, shopId, userId) {
      if (!isShow) return;
      if (!this.brandOptions[shopId]?.length) {
        this.getBrandList(shopId, userId);
      }
    },
    selectChange(v, shopId) {
      this.$set(this.valueMap, shopId, v);
    },
    // 统一构建品牌项数据结构，保证字段完整
    buildCompleteItem(raw, shopId) {
      return {
        brandId: raw && raw.vid ? raw.vid + '' : '',
        brandName: raw && raw.vvalue ? raw.vvalue : '',
        shopId: shopId,
      };
    },
    async batchFillBrand() {
      const inputBrandText = (this.inputBrandText || '').trim();
      if (!inputBrandText) return;
      if (inputBrandText === '无品牌') {
        this.shopList.forEach(shop => {
          this.$set(this.valueMap, shop.id, { brandId: 2100000000, brandName: '无品牌', shopId: shop.id });
        });
        return;
      }
      const shopIds = this.shopList.map(shop => shop.id);
      const list = await getShopsBrandFill({ brandName: this.inputBrandText, categoryId: this.categoryId, shopIds });
      list.forEach(item => {
        const { shopId, scmWxsphBrand } = item;
        const newItem = this.buildCompleteItem({ vid: scmWxsphBrand.vid, vvalue: scmWxsphBrand.name, categoryId: this.categoryId }, shopId);
        this.$set(this.valueMap, shopId, newItem);
      });
    },

    // 合并一键应用品牌配置的逻辑（支持是否跳过已有值）
    async applyBrandConfInternal({ skipExisting }) {
      const categoryId = this.categoryId;
      const categoryBrandRelations = await getApplyBrandConfig({ categoryId, baseItemId: this.baseItemId, shopType: PLATFORMID });
      const additionsMap = {};

      const existingFilledShopIds = skipExisting
        ? Object.keys(this.valueMap).filter(id => this.valueMap[id] && this.valueMap[id].brandId)
        : [];

      // 先应用类目外设置数据
      this.shopList.forEach(shop => {
        const shopId = shop.id;
        const relations = (categoryBrandRelations.find(item => shopId == item.shopId) || {}).relations || [];
        const valueItem = relations.find(item => item.categoryId == categoryId);
        if (valueItem && (!skipExisting || !existingFilledShopIds.includes(String(shopId)))) {
          additionsMap[shopId] = this.buildCompleteItem({ ...valueItem, categoryId }, shopId);
        }
      });

      // 新增逻辑：检查是否有未匹配的 shopId（从其他店铺应用）
      const unmatchedShopIds = this.shopList
        .map(shop => shop.id)
        .filter(shopId => {
          const hasRelation = categoryBrandRelations.some(
            item => item.shopId == shopId && item.relations.find(r => r.categoryId == categoryId)
          );
          const skip = skipExisting && existingFilledShopIds.includes(String(shopId));
          return !hasRelation && !skip;
        });

      if (unmatchedShopIds.length > 0) {
        const res = await ApplyToOtherShop({
          shopType: PLATFORMID,
          shopIds: unmatchedShopIds.join(','),
          categoryId,
        });
        res &&
          Object.keys(res).forEach(shopIdStr => {
            if (skipExisting && existingFilledShopIds.includes(String(shopIdStr))) return;
            const shopData = res[shopIdStr];
            if (shopData) {
              additionsMap[Number(shopIdStr)] = this.buildCompleteItem({ ...shopData, categoryId }, Number(shopIdStr));
            }
          });
      }

      const merged = Object.assign({}, this.valueMap, additionsMap);
      this.$set(this, 'valueMap', merged);
    },

    async useBrandConfInit() {
      await this.applyBrandConfInternal({ skipExisting: false });
    },
    async useBrandConf() {
      await this.applyBrandConfInternal({ skipExisting: true });
    },

    handleSetToShop(promiseConf, applyShopName) {
      this.shopDialogVisible = true;
      this.applyShopName = applyShopName;
    },
    confirmSelectShop(shops) {
      this.shopDialogVisible = false;
      this.$confirm(`选中店铺将匹配品牌【${this.applyShopName}】，匹配后将覆盖原品牌值，未匹配到将跳过，是否确认`, '提示', {
        confirmButtonText: '确定',
        type: 'warning',
      })
        .then(async () => {
          const shopIds = shops.map(item => item.id);
          const params = {
            shopType: PLATFORMID,
            shopIds: shopIds.join(','),
            categoryId: this.categoryId,
            brandName: this.applyShopName && this.applyShopName.includes('/') ? this.applyShopName.split('/')[1] : this.applyShopName || '',
          };
          const res = await ApplyToOtherShop(params);
          for (const key in res) {
            const shopInfo = res[key];
            this.$set(this.valueMap, Number(key), this.buildCompleteItem({ ...shopInfo, categoryId: this.categoryId }, Number(key)));
          }
          this.$message.success('更新品牌成功！');
        })
        .catch(() => {});
    },
    // 获取品牌
    async getBrandList(shopId, userId) {
      const isAuthorized = this.$store.getters.is_authorized_shop('wxsph', shopId);
      if (!isAuthorized || !shopId) return;
      if (!userId) {
        userId = this.$store.getters.shops_getById(shopId)?.userId;
      }
      try {
        let params = {
          userId,
          pageSize: 200,
        };
        this.$set(this.loading, shopId, true);
        const brands = await getWxsphBrandList(params);
        this.loading[shopId] = false;
        const list = brands.map(item => {
          return {
            shopId,
            brandId: item.brandId,
            brandName: item.chName || item.enName,
          };
        });
        list.unshift({
          shopId,
          brandId: 2100000000,
          brandName: '无品牌',
        });
        if (this.valueMap[shopId]) {
          const findItem = list.find(item => item.brandId === this.valueMap[shopId].brandId);
          if (!findItem) {
            this.valueMap[shopId] = null;
          } else if (!this.valueMap[shopId].brandName) {
            this.valueMap[shopId].brandName = findItem.brandName;
          }
        }
        this.$set(this.brandOptions, shopId, list);
      } catch (error) {
        console.log(error, '-----error');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.brandId-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
</style>